import React, { useContext } from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../imageService';
import { DataLayerEventContext } from '../../../contexts/dataLayerEventContext';

const shopLink = {
  rozetka: 'https://rozetka.com.ua/ua/sigareti/c4638591/filter/price=1350-1350;producer=chesterfield;tolshchina139079=obichnie/?utm_source=PMUsmsCHE26',
  cigPoshta:
    'https://cig-poshta.in.ua/shop/chesterfield-ua/swoof/price-0-to-1250/?utm_source=CDAsmsCHE26'
};

const HomeScreen = () => {
  const { sendEvent } = useContext(DataLayerEventContext);

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.headContainer}>
          <img
            className={styles.headBg}
            src={getImageFromS3('images/sms-che-ks/head-bg.png')}
            alt="bg"
          />
        </div>
        <div className={styles.formatContainer}>
          <img
            className={styles.formatBg}
            src={getImageFromS3('images/sms-che-ks/gold-bg.png')}
            alt="format-bg"
          />
          <p>
            <b>20 сигарет</b>
            <br></br>“Кінг Cайз Cтандарт”
          </p>
        </div>
        <div className={styles.bottomContainer}>
          <img
            className={styles.bottomBg}
            src={getImageFromS3('images/sms-che-ks/bottom-bg.png')}
            alt="bottom-bg"
          />
          <div className={styles.characteristicContainer}>
            <div className={styles.characteristicItem}>
              <img
                src={getImageFromS3('images/sms-che-ks/filter.png')}
                alt="filter"
              />
              <p>Ацетатний фільтр</p>
            </div>
            <div className={styles.characteristicItem}>
              <img
                src={getImageFromS3('images/sms-che-ks/tobacco.png')}
                alt="tobacco"
              />
              <p>Бленд з трьох сортів тютюну</p>
            </div>
          </div>
        </div>
        <div className={styles.buyContainer}>
          <p className={styles.title}>Де купити?</p>
          <p className={styles.description}>
            <b>Chesterfield Original</b> та <b>Chesterfield Blue</b> можна
            знайти у роздрібних точках продажу в твоєму місті або на офіційних
            онлайн сервісах, зокрема:
          </p>
        </div>
        <div className={styles.buttonContainer}>
          <button
            onClick={() => {
              sendEvent('rozetka');
              window.open(shopLink.rozetka, '_blank');
            }}
          >
            <img
              src={getImageFromS3('images/sms-che-ks/button-bg.png')}
              alt="button-bg"
            />
            <p>Rozetka</p>
          </button>
          <button
            onClick={() => {
              sendEvent('cig-poshta');
              window.open(shopLink.cigPoshta, '_blank');
            }}
          >
            <img
              src={getImageFromS3('images/sms-che-ks/button-bg.png')}
              alt="button-bg"
            />
            <p>Cig-poshta</p>
          </button>
        </div>
      </div>
      <div className={styles.footer}>
        Куріння викликає<br /> серйозні захворювання<br /> та залежність<br /> Дана інформація про<br />
        продукт надається<br /> відповідно<br /> до статті 15 Закону<br /> України «Про захист<br />
        прав споживачів»
      </div>
      <div className={styles.unsubscribe}>
        Ти отримав(-ла) лист, оскільки залишав(-ла) запит на отримання
        інформації про продукцію компаній Philip Morris в Україні. <br />
        <a href="/unsubscribe?returnLink=che_ks">
          Відписатися від SMS тут.
        </a>
      </div>
    </div>
  );
};

export default HomeScreen;
